import styled, { StyledComponentClass } from 'styled-components';

const StackedListItem: StyledComponentClass<any, any> = styled.li`
  height: 60px;
  width: 100%;
  list-style-type: none;
  display: flex;
  align-items: center;
`;

export default StackedListItem;
